/**
 * Round-level constants. These define the v0.1 scoring window and tick rate.
 */

export const SIM_HZ = 60;
export const SIM_DT = 1 / SIM_HZ;

// Shortened reveal so the first bird arrives quickly.
export const REVEAL_SECONDS = 3;
export const PLAY_SECONDS = 120;
export const TOTAL_ROUND_SECONDS = REVEAL_SECONDS + PLAY_SECONDS;

export const REVEAL_TICKS = REVEAL_SECONDS * SIM_HZ;
export const PLAY_TICKS = PLAY_SECONDS * SIM_HZ;
export const TOTAL_TICKS = REVEAL_TICKS + PLAY_TICKS;

/** Wind drift formula from docs/09 — capped per the locked rule. */
export const WIND_BASE_DRIFT_PX = 30;
export const WIND_EXP_K = 2.7;
export const WIND_DRIFT_CAP = 0.3;

export function windDriftPxPerSecond(windSpeedNorm: number): number {
  const swing = Math.min(WIND_DRIFT_CAP, 0.02 * Math.exp(WIND_EXP_K * windSpeedNorm));
  return WIND_BASE_DRIFT_PX * (1 + swing * 10);
}

/** Scoring weights (v0.1 subset). */
export const SCORE_VISIT = 5;
export const SCORE_FEED = 2;
export const SCORE_WASTE_PENALTY = -1;
export const CALM_MULT_MIN = 1.0;
export const CALM_MULT_MAX = 1.5;

export const VISIT_QUALIFY_TICKS = 3 * SIM_HZ;

/** How long a food pellet remains on the ground before decaying (seconds). */
export const FOOD_TTL_SECONDS = 20;
/** How long a bird perches before flying off (seconds). */
export const BIRD_STAY_SECONDS = 8;
/** Approximate fly-in duration (seconds). */
export const BIRD_FLYIN_SECONDS = 1.5;
/** Approximate fly-out duration (seconds). */
export const BIRD_FLYOUT_SECONDS = 1.2;
